import styled from "styled-components";
import React from "react";
import {styled as muiStyled} from "@mui/material/styles";


export const AvailabilityPageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: Outfit;
`

export const PageHeadlineContainer = styled.div`
    margin-bottom: 32px;
    padding: 20px 0;
    box-shadow: 0 20px 20px -20px rgb(0 0 0/15%);
`

export const PageHeadline = styled.div`
    max-width: 1020px;
    margin: 0 auto;
    font-size: 22px;
    font-weight: 400;
    color: #000;
    padding: 0 20px;
`

export const PageHeadlineComponent = ({ heading }) => {

    return (
        <PageHeadlineContainer>
            <PageHeadline>{heading}</PageHeadline>
        </PageHeadlineContainer>

    )
}

export const ClinicWorkforcePageContainer = muiStyled('div')(
  ({ theme }) => `
    padding: 30px 30px 15px 30px;
        display: flex;
    flex-direction: column;
    gap: 20px;
`,
)
